import { combineEpics, Epic, ofType } from "redux-observable";
import { Observable } from "rxjs";
import { map, mapTo, switchMap } from "rxjs/operators";
import { AuthActions } from "../auth/actions";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { LaunchesActions } from "./actions";
import { LaunchesDTO } from "./models/dto";
import { LaunchesService } from "./service";

const getLaunchesEpic: Epic<LaunchesActions.Actions> = (action$) =>
  action$.pipe(
    ofType(LaunchesActions.ActionTypes.getLaunches),
    switchMap<
      LaunchesActions.Actions,
      Observable<
        FetchableError | FetchableSuccess<LaunchesDTO.Responses.GetAll.T>
      >
    >(() => LaunchesService.getLaunches()),
    map((x) => LaunchesActions.setLaunches(x))
  );

const dependencies: Epic<
  AuthActions.Actions | LaunchesActions.Actions,
  LaunchesActions.Actions
> = (action$) =>
  action$.pipe(
    ofType(AuthActions.ActionTypes.authDone),
    mapTo(LaunchesActions.resetLaunches())
  );

export const launchesEpic = combineEpics(getLaunchesEpic, dependencies);
